import React from "react";
import { motion } from "framer-motion";

const COACH_IMG =
  "https://customer-assets.emergentagent.com/job_mindset-pro-2/artifacts/9q0n5dq3_IMG_9622%20%281%29.PNG";

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-20">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-[260px] md:max-w-[280px]">
            <img
              src={COACH_IMG}
              alt="Léa Mistral, préparatrice mentale"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-black/5 rounded-3xl" />
          </div>
          <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#9B8FE0] text-white px-6 py-4 rounded-2xl shadow-xl rotate-2">
            <div className="font-display font-black text-2xl">Léa Mistral</div>
            <div className="text-base opacity-95">Préparatrice mentale</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9B8FE0]">
            À propos
          </span>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
            Ma <em className="not-italic text-[#9B8FE0]">Mission</em>&nbsp;: accompagner les sportifs à comprendre et renforcer leur mental pour développer leur confiance, gérer le stress et exprimer leur plein potentiel.
          </h2>

          <div className="mt-10 space-y-4">
            {[
              {
                label: "Formation",
                text:
                  "Issue de la filière STAPS (Sciences et Techniques des Activités Physiques et Sportives), j'ai développé une expertise pointue en préparation mentale et psychologie du sport, concrétisée par deux études de recherche. Je mets la science du sport au service du bien-être et de la performance des athlètes.",
              },
              {
                label: "Spécialité",
                text:
                  "Spécialiste des sports en environnements montagneux et en conditions exigeantes, j'ai développé une approche adaptée aux situations de pression, d'endurance et d'engagement mental important.",
              },
              {
                label: "Mon approche",
                text:
                  "Rendre la préparation mentale concrète, accessible et directement applicable sur le terrain, en compétition comme à l'entraînement.",
                strong: true,
              },
            ].map((c) => (
              <div
                key={c.label}
                className="bg-white border border-zinc-200 rounded-2xl p-6 md:p-7 hover:border-[#9B8FE0]/60 hover:shadow-[0_10px_30px_-15px_rgba(155,143,224,0.45)] transition-all flex flex-col md:flex-row gap-4 md:gap-8 md:items-start"
              >
                <div className="md:w-48 md:shrink-0 text-sm md:text-base font-bold uppercase tracking-[0.18em] text-[#9B8FE0]">
                  {c.label}
                </div>
                <p
                  className={`text-base md:text-lg leading-relaxed flex-1 ${
                    c.strong ? "text-zinc-900 font-medium" : "text-zinc-700"
                  }`}
                >
                  {c.text}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
